import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { OtherInformationSubForm } from '../subforms/OtherInformation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const HeldeleStandardSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const HeldeleStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Alle mit * gekennzeichneten Felder sind Pflichtfelder und müssen ausgefüllt werden.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}